import { useEffect, useState } from "react";

import { getAHTMonitoring, getUserMaster } from "~/services/supervisor.services";
import AHTMonitoringTable from "./table";

const AHTMonitoringComponent = () => {
  const [AHTMonitoringData, setAHTMonitoringData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data, status } = await getAHTMonitoring();
      const supervisorData = await getUserMaster("lead_users");
      if (status) {
        const transformedData = (data as any).map((row: any[]) =>
          row?.reduce((acc: Record<string, any>, cell: any, index: number) => {
            const key = `Column${index + 1}`;
            if (index === 1) {
              const filteredData = supervisorData.data?.data.filter(
                (item: any) => item.id === Number(cell.stringValue)
              );
              acc[key] =
                filteredData.length > 0
                  ? filteredData[0]?.username
                  : "";
              console.log(acc[key]);
            } else {
              acc[key] = cell.stringValue || cell.longValue;
            }
            return acc;
          }, {})
        );
        setAHTMonitoringData(transformedData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    const intervalId = setInterval(fetchData, 30000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="">
      <div className="mb-4">
        <div className="flex justify-center items-center mb-3 ml-7">
          <h4 className="text-2xl font-semibold text-orange-500">
            AHT Monitoring
          </h4>
        </div>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : AHTMonitoringData.length > 0 ? (
        <div className="bg-neutral-100 rounded-lg">
          <div className="p-2">
            <AHTMonitoringTable data={AHTMonitoringData} />
          </div>
        </div>
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
};

export default AHTMonitoringComponent;
